// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { GlobalState } from './GlobalContext';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Backdrop from '@mui/material/Backdrop';
import MsgDialog from './MsgDialog';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import GroupIcon from '@mui/icons-material/Group';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';

export default function FolderInfoDialog(props) {

  // console.log("props.folder", props.folder);
  const { sysID, open, onClose, folder } = props;
  const folderID = (folder?.id == undefined ? DmsCommon.VOID_FOLDER_ID : folder?.id);
  const folderName = folder?.FolderName || "";
  const folderPath = folder?.FolderPath || "";
  const folderGrade = DmsCommon.AccessRightEnumToStr(folder?.Grade || 0);
  const folderUncPath = folder?.UncPath || "";

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const linkRef = React.useRef(null);

  const [folderLink, setFolderLink] = useState("");

  useEffect(async () => {
    // console.log("useEffect FolderInfoDialog[open]");

    if (open) {

      setShowLoading(true);

      try {

        const vParam = encodeURIComponent(Buffer.from(`sysID=${sysID}&folderID=${folderID}`).toString('base64'));
        const vUrl = `${window.location.origin}/?f=${vParam}`
        setFolderLink(vUrl);

        setShowLoading(false);

      } catch (e) {
        setShowLoading(false);

        setErrMsg(e.errMsg || e.message);
        setShowError(true);
      }


    }
  }, [open]);

  const handleCloseClick = () => {
    onClose && onClose();
  }

  async function copyTextToClipboard(aText) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(aText);
    } else {
      return document.execCommand('copy', true, aText);
    }
  }


  const [openSuccessToast, setOpenSuccessToast] = useState(false);
  const handleSuccessToastClose = () => {
    setOpenSuccessToast(false);
  }
  const [openFailToast, setOpenFailToast] = useState(false);
  const handleFailToastClose = () => {
    setOpenFailToast(false);
  }

  const handleCopyClick = () => {
    copyTextToClipboard(folderLink)
      .then(() => {
        setOpenSuccessToast(true);
      })
      .catch((err) => {
        console.log(err);
        setOpenFailToast(true);
      });
  }

  // const [gridData, setGridData] = useState([]);

  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };


  return (
    <Dialog
      open={open}
      onClose={handleCloseClick}
      fullWidth={true}
      // minWidth={"lg"}
      aria-describedby="folderLink-dialog-description"
    >
      <DialogTitle id="folderLink-dialog-title">
        Folder Info
      </DialogTitle>
      <DialogContent>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}

        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <MsgDialog
          open={showError}
          title="Error"
          msgText={errMsg}
          onClose={() => setShowError(false)}
        />

        <Snackbar
          open={openSuccessToast}
          autoHideDuration={2000}
          onClose={handleSuccessToastClose}
        >
          <Alert elevation={6} variant="filled" severity="success" sx={{ width: '100%' }}>
            Copied!
          </Alert>
        </Snackbar>

        <Snackbar
          open={openFailToast}
          autoHideDuration={2000}
          onClose={handleFailToastClose}
        >
          <Alert elevation={6} variant="filled" severity="error" sx={{ width: '100%' }}>
            Fail to copy into clipboard!
          </Alert>
        </Snackbar>

        <TextField
          id="txt-folder-id"
          label="Folder ID"
          size="small"
          value={folderID}
          fullWidth
          InputProps={{ readOnly: true, }}
          InputLabelProps={{ shrink: true, }}
          sx={{ my: 1 }}
        // variant="filled"
        />

        <TextField
          id="txt-folder-name"
          label="Folder Name"
          size="small"
          value={folderName}
          fullWidth
          InputProps={{ readOnly: true, }}
          InputLabelProps={{ shrink: true, }}
          sx={{ my: 1 }}
        // variant="filled"
        />

        <TextField
          id="txt-folder-path"
          label="Folder Path"
          size="small"
          value={folderPath}
          fullWidth
          InputProps={{ readOnly: true, }}
          InputLabelProps={{ shrink: true, }}
          sx={{ my: 1 }}
        // variant="filled"
        />

        {folderUncPath && (
          <TextField
            id="txt-folder-unc-path"
            label="UNC Path"
            size="small"
            value={folderUncPath}
            fullWidth
            InputProps={{ readOnly: true, }}
            InputLabelProps={{ shrink: true, }}
            sx={{ my: 1 }}
          />
        )}

        <TextField
          id="txt-folder-graide"
          label="Folder Permission"
          size="small"
          value={folderGrade}
          fullWidth
          InputProps={{ readOnly: true, }}
          InputLabelProps={{ shrink: true, }}
          sx={{ my: 1 }}
        // variant="filled"
        />

        {/* <div className="ag-theme-material" style={{ width: '100%', height: '50vh', }}>
          <AgGridReact

            rowData={gridData}

            defaultColDef={{
              width: 100,
              resizable: true,
              sortable: true,
              suppressMovable: true,
            }}
            columnDefs={columnDefs}
            headerHeight={40}

            suppressNoRowsOverlay

          />
        </div> */}


        <Box component="div" sx={{ display: 'flex', alignItems: 'center' }} >


          <TextField
            id="txt-folder-link"
            ref={linkRef}
            label="Link"
            size="small"
            value={folderLink}
            fullWidth
            InputProps={{ readOnly: true, }}
            InputLabelProps={{ shrink: true, }}
            sx={{ my: 1 }}
          // variant="filled"
          />
          <Button onClick={() => handleCopyClick()}>
            Copy
          </Button>

        </Box>

      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Close</Button>
      </DialogActions>
    </Dialog>

  );
}

FolderInfoDialog.propTypes = {
  sysID: PropTypes.string,
  open: PropTypes.bool,
  // docLink: PropTypes.string,
  folder: PropTypes.object,
  // folderID: PropTypes.number,
  // folderPath: PropTypes.string,
  onClose: PropTypes.func,
};
